import { matchPath } from "react-router-dom";
import { ImportListItem } from "types/import";

export const links = {
  homepage: "/",
  passwordRecovery: "/password-recovery",
  passwordReset: (id?: string) => `/password/reset/${id ?? ":id"}`,
  dashboard: "/dashboard",
  membersList: "/member",
  addMember: "/member/create",
  singleMemberGeneralInfo: (id?: string) =>
    `/single-member/${id ?? ":id"}/general-info`,
  singleMemberWallets: (id?: string) => `/single-member/${id ?? ":id"}/wallets`,
  singleMemberTimeline: (id?: string) =>
    `/single-member/${id ?? ":id"}/timeline`,
  singleMemberTiers: (id?: string) => `/single-member/${id ?? ":id"}/tiers`,
  singleMemberTransactions: (id?: string) =>
    `/single-member/${id ?? ":id"}/transactions`,
  singleMemberCustomEvents: (id?: string) =>
    `/single-member/${id ?? ":id"}/custom-events`,
  singleMemberCampaigns: (id?: string) =>
    `/single-member/${id ?? ":id"}/campaigns`,
  singleMemberAchievements: (id?: string) =>
    `/single-member/${id ?? ":id"}/achievements`,
  singleMemberRewards: (id?: string) => `/single-member/${id ?? ":id"}/rewards`,
  singleMemberReferrals: (id?: string) =>
    `/single-member/${id ?? ":id"}/referrals`,
  singleMemberBadges: (id?: string) => `/single-member/${id ?? ":id"}/badges`,
  singleMemberLeaderboards: (id?: string) =>
    `/single-member/${id ?? ":id"}/leaderboards`,
  editMember: (id?: string) => `/member/edit/${id ?? ":id"}`,
  membersConfiguration: "/members-configuration",
  segmentsList: "/segments",
  addSegment: "/segments/create",
  segment: (id?: string) => `/segments/${id ?? ":id"}`,
  editSegment: (id?: string) => `/segments/edit/${id ?? ":id"}`,
  deactivatedSegment: (id?: string) => `/deactivated-segment/${id ?? ":id"}`,
  transactionsList: "/transactions",
  transaction: (id?: string) => `/transactions/${id ?? ":id"}`,
  addTransaction: "/transactions/create",
  editTransaction: (id?: string) => `/transactions/edit/${id ?? ":id"}`,
  automationsList: "/automations",
  addAutomation: "/automations/create",
  editAutomation: (id?: string) => `/automations/edit/${id ?? ":id"}`,
  automationsImportList: "/automations/import-review",
  editImportedAutomation: "/automations/import-review/edit",
  automation: (id?: string) => `/automations/${id ?? ":id"}`,
  campaignsList: "/campaigns",
  campaignsImportList: "/campaigns/import-review",
  editImportedCampaign: "/campaigns/import-review/edit",
  addCampaign: "/campaigns-create",
  simulateCampaign: "/campaigns-simulate",
  campaign: (id?: string) => `/campaigns/${id ?? ":id"}`,
  editCampaign: (id?: string) => `/campaigns/edit/${id ?? ":id"}`,
  referralsList: "/referrals",
  referral: (id?: string) => `/referrals/${id ?? ":id"}`,
  addReferral: "/referrals/create",
  editReferral: (id?: string) => `/referrals/edit/${id ?? ":id"}`,
  referralsImportList: "/referrals/import-review",
  editImportedReferral: "/referrals/import-review/edit",
  redemptionCodeList: (id?: string) =>
    `/campaigns/${id ?? ":id"}/redemption-codes`,
  achievementsList: "/achievements",
  achievementsImportList: "/achievements/import-review",
  addAchievement: "/achievements-create",
  achievement: (id?: string) => `/achievements/${id ?? ":id"}`,
  editAchievement: (id?: string) => `/achievements/edit/${id ?? ":id"}`,
  editImportedAchievement: "/achievements/import-review/edit",
  achievementTemplates: "/achievement-templates",
  tiersList: "/tiers",
  tierSetList: "/tier-sets/",
  addTier: "/tiers/create",
  editTier: (id?: string) => `/tiers/edit/${id ?? ":id"}`,
  addTierSet: "/tier-set/create",
  tierSet: (id?: string) => `/tier-set/${id ?? ":id"}`,
  tierSetAddTiers: (id?: string) => `/tier-set/${id ?? ":id"}/create`,
  tierSetEditTiers: (id?: string) => `/tier-set/${id ?? ":id"}/edit`,
  tiersConfiguration: "/tiers-configuration",
  editTierSet: (id?: string) => `/tier-set/edit/${id ?? ":id"}`,
  unitTransfers: "/units-transfers",
  rewardCategoriesList: "/reward-categories",
  rewardsList: "/rewards",
  addReward: "/rewards/create",
  editReward: (id?: string) => `/rewards/edit/${id ?? ":id"}`,
  rewardsConfiguration: "/rewards-configuration",
  rewardFulfillmentsList: "/rewards-fulfillment",
  rewardsFulfillment: (id?: string) => `/rewards-fulfillment/${id ?? ":id"}`,
  reward: (id?: string) => `/rewards/${id ?? ":id"}`,
  rewardsImportList: "/rewards/import-review",
  editImportedReward: "/rewards/import-review/edit",
  communication: "/communication",
  customEventsList: "/events",
  referredMembersList: "/referred-members",
  customEvent: (id?: string) => `/events/${id ?? ":id"}`,
  customEventsSchemaList: "/schemas",
  addCustomEventSchema: "/schemas/create",
  editCustomEventSchema: (id?: string) => `/schemas/edit/${id ?? ":id"}`,
  customEventSchemaImportList: "/schema/import-review",
  editImportedCustomEventSchema: "/schema/import-rewiev/edit",
  adminData: "/admin-data",
  changePassword: "/change-password",
  walletTypesList: "/wallet-types",
  wallet: (id?: string) => `/wallet-types/${id ?? ":id"}`,
  addWalletType: "/wallet-types/create",
  editWalletType: (id?: string) => `/wallet-types/edit/${id ?? ":id"}`,
  walletsImportList: "/wallets/import-review",
  editImportedWallet: "/wallets/import-review/edit",
  webhookList: "/webhook",
  addWebhook: "/webhook/create",
  editWebhook: (id?: string) => `/webhook/edit/${id ?? ":id"}`,
  importDetails: (type?: ImportListItem["type"], id?: string) =>
    `/imports/import-details/${type}/${id ?? ":id"}`,
  importsExports: "/imports-exports",
  collectionsList: "/collections",
  collection: (id?: string) => `/collections/${id ?? ":id"}`,
  addCollection: "/add-collection",
  editCollection: (id?: string) => `/collections/edit/${id ?? ":id"}`,
  systemLogs: "/system-logs",
  globalAnalytics: "/global-management/analytics",
  settings: "/global-management/settings",
  configDuplication: "/global-management/resources",
  configDuplicationImport: "/global-management/resources/import-review",
  usage: "/global-management/usage",
  addLanguage: "/global-management/settings/language/create",
  editLanguage: (id?: string) =>
    `/global-management/settings/language/edit/${id ?? ":id"}`,
  editTranslation: (id?: string) =>
    `/global-management/settings/translations/edit/${id ?? ":id"}`,
  addStore: "/global-management/settings/stores-list/create",
  editStore: (id?: string) =>
    `/global-management/settings/stores-list/${id ?? ":id"}`,
  addRole: "/global-management/settings/roles-list/create",
  editRole: (id?: string) =>
    `/global-management/settings/roles-list/edit/${id ?? ":id"}`,
  addAdmin: "/global-management/settings/admins-list/create",
  editAdmin: (id?: string) =>
    `/global-management/settings/admins-list/edit/${id ?? ":id"}`,
  channelList: "/channels",
  addChannel: "/channels/create",
  editChannel: (id?: string) => `/channels/edit/${id ?? ":id"}`,
  actionDetails: (id?: string) => `/actions/action-details/${id ?? ":id"}`,
  oktaLoginCallback: "/login/callback",
  leaderboardsList: "/leaderboards",
  addLeaderboard: "/leaderboards/create",
  editLeaderboard: (id?: string) => `/leaderboards/edit/${id ?? ":id"}`,
  leaderboard: (id?: string) => `/leaderboards/${id ?? ":id"}`,
};

export const checkPathsMatches = (
  currentLocation: string,
  linkName: string | ((id?: string) => string),
) => {
  return matchPath(
    typeof linkName == "string" ? linkName : linkName(),
    currentLocation,
  );
};
